{
  "production":"Production",
  "delay":"Delay",
  "gantt":"Gantt",
  "profile":"Profile",
  "search":"Search",
  "inUser":"In use",
  "idle":"Idle",
  "down":"Down",
  "logout":"Sign Out",
  "email":"Email",
  "password":"Password",
  "rememberMe":"Remember me",
  "signIn":"Sign In",
  "alarms":"Alarms",
  "factoryDay":"Factory day",
  "shift":"Shift",
  "crew":"Crew",
  "from":"From",
  "to":"To",
  "range":"Range",
  "filterType":"Filter type",
  "filter":"Filter",
  "all":"All",
  "currentWeek":"Current week",
  "lastWeek":"Last week",
  "last7Days":"Last 7 days",
  "currentMonth":"Current month",
  "lastMonth":"Last month",
  "last30Days":"Last 30 days",
  "realTime": "Realtime",
  "session": "Sessions",
  "machine": "Machine",
  "update": "Update",
  "month_1": "January",
  "month_2": "February",
  "month_3": "March",
  "month_4": "April",
  "month_5": "May",
  "month_6": "June",
  "month_7": "July",
  "month_8": "August",
  "month_9": "September",
  "month_10": "October",
  "month_11": "November",
  "month_12": "December"
}
